import { CustomerUpdatePage } from "@/features/customer/pages/CustomerUpdatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/customer/$id/update")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["customer.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: CustomerUpdatePage,
});
